import { AlertTriangle, X } from "lucide-react";

export const ConfirmModal = ({
  isOpen,
  title = "Confirmar exclusão",
  message,
  onConfirm,
  onCancel,
  confirmLabel = "Excluir",
  danger = true,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 animate-fade-in bg-gray-900/30 backdrop-blur-[2px]" onClick={onCancel} />
      <div className="relative w-full max-w-sm rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-5 py-4">
          <div className="flex items-center gap-2">
            {danger && <AlertTriangle className="h-4 w-4 text-red-500" />}
            <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          </div>
          <button type="button" onClick={onCancel} className="text-gray-400 hover:text-gray-600">
            <X className="h-4 w-4" />
          </button>
        </div>

        <div className="px-5 py-4">
          {message && <p className="mb-4 text-sm text-gray-600">{message}</p>}
          <div className="flex gap-2">
            <button
              type="button"
              onClick={onCancel}
              className="flex-1 rounded-xl border border-gray-200 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`flex-1 rounded-xl px-4 py-2 text-sm font-medium text-white transition-colors ${
                danger ? "bg-red-600 hover:bg-red-700" : "bg-accent hover:bg-accent-hover"
              }`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
